
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 1000 1000"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M500 937c161.9-51.5 292.7-213.6 344.4-375.1S883 219.5 800.2 71.3C618.1 112.2 500 58.6 500 58.6s-118.1 53.6-300.2 12.7c-82.8 148.2-95.8 329-44.1 490.6C207.3 723.4 338.1 885.5 500 937z"}}),_c('path',{attrs:{"d":"M500 87.6c23.3 8.5 81.5 26.1 165.1 26.1 39.6 0 80.2-4 120.8-11.8 15.2 29.7 27.8 61.1 37.5 93.6 11.4 38.1 18.9 78 22.4 118.4 3.4 40 2.8 80.7-1.7 121-4.6 40.3-13.1 80.3-25.4 118.8-25 78.2-69.6 156.1-125.4 219.2C635.7 838 569 884.7 500 908.6c-69-23.8-135.7-70.6-193.3-135.7-55.8-63.1-100.3-140.9-125.4-219.2-12.3-38.5-20.9-78.5-25.4-118.8-4.6-40.3-5.1-81-1.7-121 3.4-40.4 11-80.2 22.4-118.4 9.7-32.5 22.3-63.9 37.5-93.6 40.7 7.9 81.2 11.8 120.8 11.8 83.6 0 141.8-17.6 165.1-26.1"}}),_c('path',{attrs:{"d":"M206.5 460.7l61.1-86.6c3.5-5 9.3-8 15.4-8s11.7 2.9 15.3 7.8l62.3 86.8h-108l18.2-24.3h38.8l-26.7-37.6-43.7 61.9h-32.7zm163.7 0h30.3v-24.3h60.6c19.4 0 35.2-15.7 35.2-35.2 0-19.4-15.7-35.2-35.2-35.2h-71.6l-19.4 24.3h85.5c6.4 0 11.5 5.2 11.5 11.5 0 6.4-5.2 11.5-11.5 11.5h-85.5v47.4zm131-94.6l59.3 84.2c4.6 6.5 12.1 10.4 20.1 10.4 8 0 15.5-3.9 20.1-10.4l59.3-84.2h-38.8L580 426.7l-40-60.6h-38.8zm193.5 0c-15.7 0-28.5 12.8-28.5 28.5s12.8 28.5 28.5 28.5h63.1a6.7 6.7 0 010 13.4h-77l-19.4 24.3H765c15.7 0 28.5-12.8 28.5-28.5s-12.8-28.5-28.5-28.5h-64.9c-4 0-7.3-3.3-7.3-7.3s3.3-7.3 7.3-7.3h70.3l18.2-23h-93.9z"}})])
          )
        }
      }
    